import theme from '../../../lib/theme';
import { TypographyProps } from './Typography';

const {
  scale,
  colors,
  media,
  font: {
    families,
    heights,
    spacings,

    ...font
  },
} = theme;

export default ({
  fluid = true,
  brand = 'sas',
  color = 'black',
  family = 'primary',
  linkColor = 'primary',
  linkDecoration = 'underline',
  size = 'm',
  align,
  weight,
}: TypographyProps) => ({
  container: {
    color: colors[brand][color] || colors[color],
    fontSize: font[size],
    fontFamily: families[family],
    fontWeight: font[weight || 'normal'],
    lineHeight: heights[size],
    letterSpacing: spacings.m,
    textAlign: align,

    '> *': {
      marginBottom: '0',
    },
    
    '& h1': {
      fontSize: font.xxxl,
      fontWeight: font[weight || 'bold'],
      lineHeight: heights.xxxl,

      ...(!fluid
        ? {}
        : {
            [media.s.down]: {
              fontSize: font.xxl,
              lineHeight: heights.xxl,
            },
          }),
    },

    '& h2': {
      fontSize: font.xxl,
      fontWeight: font[weight || 'bold'],
      lineHeight: heights.xxl,

      ...(!fluid
        ? {}
        : {
            [media.s.down]: {
              fontSize: font.xl,
              lineHeight: heights.xl,
            },
          }),
    },

    '& h3': {
      fontSize: font.xl,
      fontWeight: font[weight || 'bold'],
      lineHeight: heights.xl,

      ...(!fluid
        ? {}
        : {
            [media.s.down]: {
              fontSize: font.l,
              lineHeight: heights.l,
            },
          }),
    },

    '& h4': {
      fontSize: font.l,
      lineHeight: heights.l,
      fontWeight: font[weight || 'normal'],
    },

    '& h5': {
      fontSize: font.m,
      lineHeight: heights.m,
      fontWeight: font[weight || 'normal'],
    },

    '& h6': {
      fontSize: font.s,
      lineHeight: heights.s,
      fontWeight: font[weight || 'normal'],
    },

    '& h1, & h2, & h3, & h4, & h5, & h6': {
      marginBottom: scale.xxs,
    },

    '& h1:last-child, & h2:last-child, & h3:last-child, & h4:last-child, & h5:last-child, & h6:last-child': {
      marginBottom: 0,
    },

    '& img': {
      width: '100%',
      height: 'auto',
    },

    '& a': {
      cursor: 'pointer',
      textDecoration: linkDecoration,
      color: colors[brand][linkColor] || colors[linkColor],
      transition: 'all 150ms linear',

      '&:hover': {
        color: colors[brand].accent,
      },
    },

    '& small': {
      fontSize: font.s,
      lineHeight: heights.s,
    },

    '& strong': {
      fontWeight: font.bold,
    },

    '& p': {
      marginBottom: scale.s,
    },

    '& p:last-child': {
      marginBottom: 0,
    },

    '& blockquote': {
      fontWeight: font.normal,
      fontStyle: 'italic',
      fontSize: font.m,
      lineHeight: heights.m,
      letterSpacing: spacings.m,
      margin: `0 0 ${scale.s} 0`,
    },

    '& hr': {
      height: 3,
      backgroundColor: colors.grey,
      width: '100%',
      marginTop: scale.m,
      marginBottom: scale.m,
    },

    '& iframe': {
      maxWidth: '100%',
    },

    '& iframe + *': {
      marginTop: scale.s,
    },

    '& twitterwidget + *': {
      marginTop: scale.s,
    },

    '& figure': {
      margin: `0 0 ${scale.s}`,
      maxWidth: '100%',
    },

    '& figure img': {
      margin: 0,
    },

    '& figcaption': {
      marginTop: scale.xxs,
      color: colors.black,
      fontSize: font.s,
      lineHeight: heights.s,
      fontWeight: font.normal,
      letterSpacing: spacings.m,
    },

    '& td': {
      border: `1px solid ${colors.light_grey}`,
      padding: `${scale.xxxs} ${scale.xxs}`,
    },
  },
});
